import AddBook from "../add/AddBook";

export default function Add() {
    return (
        <main className="py-6 2xl:px-6">
            <div className="container">
                <AddBook />
            </div>
        </main>
    );
}
